import { Api } from '@sodamnfoolish/sjc-backend-types';
import { useBackend } from './UseBackend';
import { usePumpGateway } from './usePumpGateway';
import { CommonUseBubblesProps, useBubbles } from './useBubbles';

export function usePumpFunBubbles(props: CommonUseBubblesProps) {
    // TODO: useBackend not neccessary to be a hook, probably can be single instance
    const { getPumpFunBubbles } = useBackend();

    const { pumpGatewayClient } = usePumpGateway();

    return useBubbles<Api.Pump.DTO.PumpFunBubble, Api.Pump.DTO.PumpFunBubbleUpdate>({
        ...props,
        getBubbles: getPumpFunBubbles,
        client: pumpGatewayClient,
        updateEventName: Api.Pump.Gateway.Event.BubbleUpdate,
    });
}
